import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';

@Injectable()
export class FacebookRedirectGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const urlSearchParams = new URLSearchParams(route.fragment);
        const community = this.authenticationService.community;
        const facebookToken = urlSearchParams.get('access_token');
        const type = urlSearchParams.get('state');

        if (community) {
            if (facebookToken && type) {
                this.router.navigate([`/${community}/community/installation/facebook`], {
                    queryParams: { access_token: facebookToken, type },
                });
            } else {
                this.router.navigate([`/${community}/community/installation/facebook`]);
            }
        }

        return true;
    }
}
